












import Vue from "vue";
import { Component } from "vue-property-decorator";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

@Component({
  name: "PageForgotPassword",
  components: { PageTitle, BasePage, BaseButton, BaseInput },
})
export default class PageForgotPassword extends Vue {
  public email = "";

  public loading = false;

  public async submit() {
    this.loading = true;
    try {
      await providers.PasswordResetProvider.start({ data: { email: this.email } });
    } finally {
      this.$router.push({ name: "loginForgotEmail", params: { email: this.email } });
      this.loading = false;
    }
  }
}
